<template>

    <div class="page-widget" :class="classes">
        <div v-if="title" class="page-widget-header">
            <span class="title">{{ title }}</span>
            <a class="action" href="#" @click.prevent="actionFunc">{{ actionTitle }}</a>
        </div>
        <div v-if="$slots['body']" ref="body" class="page-widget-body" :style="styles">
            <slot name="body"></slot>
        </div>
        <div v-if="expandable" class="page-widget-footer">
            <a v-if="expanded" href="#" @click.prevent="toggle">Collapse</a>
            <a v-else href="#" @click.prevent="toggle">Expand</a>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .page-widget {

        @include scrollbar();
        margin-bottom: 10px;
        position: relative;
        width: 100%;

        > :first-child {
            border-radius: 5px 5px 0 0;
        }
        > :last-child {
            border-radius: 0 0 5px 5px;
        }
        > :only-child {
            border-radius: 5px;
        }

        &.empty {
            .page-widget-body {
                @include font-medium(13px);
                align-items: center;
                color: $color-muted;
                display: flex;
                justify-content: center;
            }
        }

        &.expanded {
            .page-widget-body {
                max-height: unset !important;
            }
        }

        .page-widget-header {
            align-items: center;
            background: #fff;
            border: 1px solid $color-rule;
            border-bottom: none;
            display: flex;
            justify-content: space-between;
            min-height: 40px;
            padding: 10px 15px;
            .title {
                @include font-medium(14px);
                align-items: center;
                display: flex;
                justify-content: space-between;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .action {
                @include font-semibold(11px);
                color: $color-muted;
                text-decoration: none;
                &:hover {
                    color: $color-text;
                    text-decoration: underline;
                }
            }
        }

        .page-widget-body {
            background: #fff;
            border: 1px solid $color-rule;
            overflow: auto;
            padding: 20px;
            p {
                @include font-medium(13px);
                color: $color-text;
                line-height: 1.6em;
                margin: 0 0 15px 0;
            }
        }

        .page-widget-footer {
            @include font-medium(13px);
            background: #fff;
            border: 1px solid $color-rule;
            border-top: none;
            padding: 15px;
            text-align: center;
            a {
                color: $color-muted;
                &:hover {
                    color: $color-text;
                }
            }
        }

    }

</style>

<script>

export default {

    props: {
        title: {
            type: String,
        },
        canExpand: {
            type: Boolean,
            default: true,
        },
        empty: {
            type: Boolean,
            default: false,
        },
        actionTitle: {
            type: String,
        },
        actionFunc: {
            type: Function,
        },
    },

    data() {
        return {
            maxHeight: 500,
            expandable: false,
            expanded: false,
        }
    },

    mounted() {
        let height = this.$refs.body.clientHeight;
        if (height >= this.maxHeight - 2) {
            this.expandable = true;
        }
    },

    computed: {

        classes() {
            return {
                empty: this.empty,
                expanded: this.expanded,
            };
        },

        styles() {
            return {
                'max-height': `${this.maxHeight}px`,
            };
        },

    },

    watch: {

        canExpand(val) {
            this.expandable = val;
        },

    },

    methods: {

        toggle() {
            this.expanded = !this.expanded;
        },

    },

}

</script>